// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2kuhp","topBottomGutter":"Layout_topBottomGutter__3x319"};